// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`Team model belongsTo relations 1`] = `
Array [
  "Office",
]
`;
